export const BASE_PAGE = "/";
export const COLOR_MAP_PAGE = "/colormap";
export const GENERATE_TEMPLATE_PAGE = "/generateTemplate";
export const PORTFOLIOS_PAGE = "/portfolios";
export const PORTFOLIO_PAGE = "/portfolio/:id";
export const PORTFOLIO_WORKSPACE_PAGE = `${PORTFOLIO_PAGE}/:workspaceId`;
export const PORTFOLIO_CASHFLOW_ROUTE = "PflCffProjections";
export const PORTFOLIO_CASHFLOW_PROJECTIONS_PAGE = `${PORTFOLIO_WORKSPACE_PAGE}/${PORTFOLIO_CASHFLOW_ROUTE}`;
export const COMMITMENT_PACING_PAGE = `${PORTFOLIO_PAGE}/pacing`;
export const ASSETS_PAGE = "/assets";
export const ASSET_PAGE = "/asset/:id";
export const MANAGERS_PAGE = "/managers";
export const MANAGER_PAGE = "/manager/:id";
export const FUNDS_PAGE = "/funds";
export const FUND_PAGE = "/fund/:id";
export const FUND_SERIES_LIST_PAGE = "/fund-series";
export const FUND_SERIES_PAGE = "/fund-series/:id";
export const INVESTOR_ID = "?investorId=";
export const ADMINISTRATION_PAGE = "/administration";
export const ADMINISTRATION_CATEGORY_PAGE = "/administration/:category?/:page?";
export const PRIVATE_EQUITY_BENCHMARKS_PAGE = "/administration/market-data/private-equity-benchmarks";
export const ACCESSGATE_PAGE = "/accessgate";
export const DATA_PAGE = "/data";
export const MARKETS_PAGE = "/markets";
export const MARKET_PAGE = "/market/:id";
export const COMMITMENT_PACING_PLANS_PAGE = "/pacing-plans";
export const CAMPAIGNS_PAGE = "/campaigns";
export const CLICKTHROUGH_PAGE = "/clickthrough";
export const DOCUMENT_SERVICE_PAGE = "/documentservice";
export const MARKET_MAP_PAGE = "/market-map";
export const PEER_COMPARISON_PAGE = "/peer-comparison";
export const J_CURVES_PAGE = "/j-curves";
export const CUSTOM_INDICES_PAGE = "/custom-indices";
export const NOTES_PAGE = "/notes";
